import PortalIdParser from 'PortalIdParser';
import noAuthHttp from 'conversations-http/clients/noAuthApiClient';
import { getThirtyDaysAgoFormatted, getTodayFormatted } from '../utils/getFormattedDate';
import Raven from 'raven-js';
function getDomainFromUrl(knowledgeBaseUrl) {
  try {
    return new URL(knowledgeBaseUrl).hostname;
  } catch (error) {
    Raven.captureException(new Error('Invalid knowledge base URL'));
    return '';
  }
}
function fetchArticles({
  knowledgeBaseId,
  knowledgeBaseUrl,
  kbRecommendationType
}) {
  const domain = getDomainFromUrl(knowledgeBaseUrl);
  const portalId = PortalIdParser.get();
  const prefix = !kbRecommendationType || kbRecommendationType === 'TRENDING' ? 'most-viewed' : 'most-helpful';
  return noAuthHttp.post(`https://${domain}/_hcms/livechat/kb/${prefix}-articles?portalId=${portalId}`, {
    withCredentials: true,
    data: {
      startDate: getThirtyDaysAgoFormatted(),
      endDate: getTodayFormatted(),
      knowledgeBaseId,
      limit: 5
    }
  });
}
export function getRecommendedArticles({
  knowledgeBaseId,
  knowledgeBaseUrl,
  kbRecommendationType
}) {
  return fetchArticles({
    knowledgeBaseId,
    knowledgeBaseUrl,
    kbRecommendationType
  });
}
export function getArticleCategories({
  knowledgeBaseId,
  knowledgeBaseUrl
}) {
  const domain = getDomainFromUrl(knowledgeBaseUrl);
  const portalId = PortalIdParser.get();
  return noAuthHttp.get(`https://${domain}/_hcms/livechat/kb/categories-with-count?portalId=${portalId}&knowledgeBaseId=${knowledgeBaseId}`, {
    withCredentials: true
  });
}
export function getCategoryArticles({
  categoryId,
  knowledgeBaseId,
  knowledgeBaseUrl
}) {
  const domain = getDomainFromUrl(knowledgeBaseUrl);
  const portalId = PortalIdParser.get();
  return noAuthHttp.get(`https://${domain}/_hcms/livechat/kb/articles-in-category?portalId=${portalId}&knowledgeBaseId=${knowledgeBaseId}&categoryId=${categoryId}`, {
    withCredentials: true
  });
}